import React from 'react';
import { Store } from '@/lib/types';
import { getAvailableStates, getStateName } from '@/lib/utils';
import {
  Badge,
  Card,
  CardContent
} from "@geely/ui";
import { Loader2, MapPin } from 'lucide-react';

interface StateSelectorProps {
  stores: Store[];
  isLoading?: boolean;
  selectedState: string;
  onSelectState: (state: string) => void;
}

export function StateSelector({ stores, isLoading, selectedState, onSelectState }: StateSelectorProps) {
  const states = getAvailableStates(stores);

  if (isLoading) {
    return (
      <div className="space-y-3">
        <h3 className="font-medium text-[#080404]">Selecione o Estado</h3>
        <div className="flex flex-col items-center justify-center py-12 text-[#64748b]">
          <Loader2 className="size-8 animate-spin mb-3" />
          <p className="text-sm">Carregando estados disponíveis...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <h3 className="font-medium text-[#080404]">Selecione o Estado</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {states.map(state => {
          const storesCount = stores.filter(s => s.state === state).length;
          const isSelected = selectedState === state;

          return (
            <Card
              key={state}
              className={`cursor-pointer transition-all hover:shadow-md ${
                isSelected
                  ? 'border-[#000000] border-2 bg-[#000000]/5'
                  : 'border-[#e2e8f0] hover:border-[#000000]/30'
              }`}
              onClick={() => onSelectState(state)}
            >
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                      isSelected ? 'bg-[#000000]' : 'bg-[#e2e8f0]'
                    }`}>
                      <MapPin className={`size-5 ${
                        isSelected ? 'text-white' : 'text-[#64748b]'
                      }`} />
                    </div>
                    <div>
                      <p className={`font-semibold ${
                        isSelected ? 'text-[#000000]' : 'text-[#080404]'
                      }`}>
                        {state}
                      </p>
                      <p className="text-xs text-[#64748b]">
                        {getStateName(state)}
                      </p>
                    </div>
                  </div>
                  <Badge variant="outline" className="text-xs">
                    {storesCount} {storesCount === 1 ? 'loja' : 'lojas'}
                  </Badge>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
